var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { staticClass: "min-h-screen" },
    [
      _c(
        "v-app-bar",
        {
          class: _vm.$vuetify.breakpoint.smAndUp ? "px-6" : null,
          attrs: {
            app: "",
            color: "white",
            height: "100",
            "elevate-on-scroll": "",
          },
        },
        [
          _c(
            "a",
            { attrs: { href: "https://musicologielessons.com" } },
            [_c("jet-application-logo", { staticClass: "block h-9 w-auto" })],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showForm
        ? _c("SoliForm", {
            ref: "form",
            attrs: {
              title: "We want to hear from you!",
              "text-subtitle":
                "We're constantly working to improve and we want\n                            to know what went right, and what we can do\n                            better.",
              persistent: "",
              permanent: "",
            },
            on: {
              submit: function ($event) {
                return _vm.submit(true)
              },
              reset: function ($event) {
                _vm.showForm = false
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "v-row",
                        { staticStyle: { "justify-content": "space-evenly" } },
                        [
                          _c(
                            "v-btn-toggle",
                            {
                              attrs: { mandatory: "" },
                              model: {
                                value: _vm.form.rating,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "rating", $$v)
                                },
                                expression: "form.rating",
                              },
                            },
                            _vm._l([1, 2, 3, 4, 5], function (i, idx) {
                              return _c(
                                "div",
                                { key: idx, staticClass: "pa-2" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "round",
                                      attrs: {
                                        small: "",
                                        height: "55",
                                        width: "55",
                                        color:
                                          i == _vm.form.rating
                                            ? "soli-blue"
                                            : null,
                                        value: i,
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "flex-col" }, [
                                        _c(
                                          "div",
                                          {
                                            class: [
                                              i == _vm.form.rating
                                                ? "white--text"
                                                : "soli-grey",
                                              "text-xl",
                                            ],
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(i) +
                                                "\n                                            "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  i == _vm.form.rating
                                    ? _c(
                                        "small",
                                        { staticClass: "flex pt-2 soli-grey" },
                                        [_vm._v("Your rating")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("v-textarea", {
                        ref: "notes",
                        staticClass: "soli-round",
                        attrs: {
                          outlined: "",
                          dense: "",
                          label: "Please leave feedback",
                          rules: [
                            (v) =>
                              (v || "").length <= 255 ||
                              `Character limit reached`,
                          ],
                        },
                        model: {
                          value: _vm.form.comment,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "comment", $$v)
                          },
                          expression: "form.comment",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              69781486
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showThankYou
        ? _c(
            "div",
            {
              staticClass:
                "flex sm:justify-center pt-6 sm:pt-0 overflow-hidden",
            },
            [
              _c(
                "v-container",
                { staticClass: "flex justify-center align-center" },
                [
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "flex-col" },
                      [
                        _c("lottie-player", {
                          staticStyle: { width: "inherit", height: "300px" },
                          attrs: {
                            src: "https://assets3.lottiefiles.com/packages/lf20_no08B3.json",
                            background: "transparent",
                            speed: "1",
                            loop: "",
                            autoplay: "",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "v-card-title",
                          { staticClass: "soli-grey justify-center" },
                          [_vm._v("Thank you!")]
                        ),
                        _vm._v(" "),
                        _c("SoliBtn", {
                          staticClass: "justify-center w-full",
                          attrs: {
                            text: "Return Home",
                            href: _vm.route("login"),
                            gradient: "gradient-blue",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }